import {Component, Input, Output, EventEmitter, ViewEncapsulation, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ColorPickerService, Rgba } from 'ngx-color-picker'

export interface CustomSequenceLightFormInterface {
  value: number | boolean;
}

@Component({
  templateUrl: './park-custom-sequence-light-form.html',
  selector: 'park-custom-sequence-light-form',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./park-custom-sequence-light-form.css'],
})

export class ParkCustomSequenceLightFormComponent implements OnInit {
  @Input() color: number | boolean;
  @Output() changeCustomSequenceLight = new EventEmitter<CustomSequenceLightFormInterface>();

  private modalReference: any;
  public lightSequenceForm: FormGroup;
  public hexColor: string;
  inProgress = false;

  private c_light: string;

  constructor(private modalService: NgbModal, private cpService: ColorPickerService) {
    this.lightSequenceForm = new FormGroup({
      c_light: new FormControl(''),
    })
  }

  public onChangeColor(c_light: string): void {
    this.c_light = c_light;
    this.lightSequenceForm.patchValue({ c_light });
  }

  public clearColor(): void {
    this.c_light = '';
    this.lightSequenceForm.patchValue({ c_light: '' });
    this.changeLight({ value: { c_light: '' }, valid: true });
  }

  open(content) {
    this.modalReference = this.modalService.open(content, {windowClass: 'light-modal gray-modal'});
  }

  public changeLight({ value, valid}) {
    this.inProgress = true;
    const val = value.c_light.trim().replace('#', '');
   
    setTimeout(() => {
      if (valid) {
        this.changeCustomSequenceLight.emit({
          // color can be 0
          value: val !== "" ? parseInt(val, 16) : false
        });
      }
    }, 0);
  }

  ngOnInit(): void {
    let convertedColor = (this.color as number).toString(16);
    this.hexColor = (typeof this.color === 'number') && ('#' + (convertedColor.length <=2 ? '0000' + convertedColor : convertedColor.length <=4 ? '00' + convertedColor : convertedColor));
    this.c_light = (typeof this.color === 'number') ? this.hexColor : '';
    this.onChangeColor(this.c_light);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/forms/park-custom-sequence-light-form/park-custom-sequence-light-form.component.ts